import styled from "styled-components";

export const LoginInputContainer = styled.div`
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const Form = styled.form`
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.8rem;
    margin-bottom: 3px;
    color: #104467;
  }

  input {
    margin-bottom: 20px;
    height: 40px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid rgba(16, 68, 103, 0.34);
  }

  .erro {
    color: red;
    margin: 10px 0;
    display: flex;
    justify-content: center;
    font-size: 15px;
    align-self: start;
  }
`;

export const ForgetPasswordContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  width: 100%;
`;

export const ForgetPassword = styled.span`
  font-size: 0.75rem;
  cursor: pointer;
`;

export const RegisterButton = styled.button`
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: #104467;
`;
